import React, { memo } from "react";
import BarChart from "./components/BarChart";
import PieChart from "./components/PieChart";
import DonutChart from "./components/DonutChart";
import LineChart from "./components/LineChart";
import PyramidChart from "./components/PyramidChart";

const COMPONENT_MAP = {
  bar: BarChart,
  pie: PieChart,
  donut: DonutChart,
  line: LineChart,
  pyramid: PyramidChart,
};

function DynamicChart({ type = "bar", data = [], height = 300, ...props }) {
  if (!data || data.length === 0) {
    return (
      <div style={{ color: "#9ca3af", fontSize: 13, padding: "20px 0", textAlign: "center" }}>
        Tidak ada data untuk ditampilkan
      </div>
    );
  }

  const chartHeight = Math.max(height - 45, 150);
  const ChartComponent = COMPONENT_MAP[type];

  if (!ChartComponent) {
    return (
      <div style={{ color: "#9ca3af", fontSize: 13, padding: 20 }}>
        Tipe visualisasi tidak dikenal: {type}
      </div>
    );
  }

  return <ChartComponent data={data} height={chartHeight} {...props} />;
}

export default memo(DynamicChart);
